// libs
import * as React from 'react'
import { connect } from 'react-redux'

// interfaces / constants
import { ActivableNavigationItems } from 'src/components/header/navigation/header_navigation'
import { POPUP_TYPE_MAP } from 'src/interfaces/app-state'
import { IRootState } from 'src/reducers/interface'

// components
import MapContainer, { IMapSettings } from 'src/containers/map'
import LayoutBase from 'src/layout/base/layout_base'
import { ILocationShape } from '../interfaces/location'
import { IMapGeoJsonLayer } from '../interfaces/map'
import { IMarker } from '../interfaces/marker'

// helpers

export interface LayoutMapContainerProps {
  markers?: IMarker[];
  locationShape?: ILocationShape;
  subHeader?: JSX.Element;
  activeNavigationItem?: ActivableNavigationItems;
  mapSettings?: IMapSettings;
  showLocationShapeControls?: boolean;
  enableMapToggler?: boolean;
  pageTitle: JSX.Element;
  withHeaderMargin?: boolean;
  geoJsonLayers?: IMapGeoJsonLayer[];
}

interface IStateToProps {
  isMapShown: boolean;
  loggedIn: boolean;
  showBanner: boolean;
}

type IProps = LayoutMapContainerProps & IStateToProps;

const mapStateToProps = ({ appState, user }: IRootState): IStateToProps => {
  return {
    isMapShown: appState.activePopupMenu === POPUP_TYPE_MAP,
    loggedIn: user.loggedIn,
    showBanner: !user.loggedIn
  }
}

const LayoutMap: React.FC<IProps> = ({
  activeNavigationItem,
  subHeader,
  isMapShown,
  children,
  showBanner,
  mapSettings,
  showLocationShapeControls = true,
  enableMapToggler = true,
  pageTitle,
  markers,
  locationShape,
  withHeaderMargin = false,
  geoJsonLayers
}) => {
  return (
    <LayoutBase
      subHeader={subHeader}
      activeNavigationItem={activeNavigationItem}
      isMapShown={isMapShown}
      showBanner={showBanner}
      pageTitle={pageTitle}
      withHeaderMargin={withHeaderMargin}
      enableMapToggler={enableMapToggler}
      sideBarContent={
        <MapContainer
          markers={markers}
          locationShape={locationShape}
          settings={mapSettings}
          showLocationShapeControls={showLocationShapeControls}
          geoJsonLayers={geoJsonLayers}
        />
      }
    >
      {children}
    </LayoutBase>
  )
}
export default connect<IStateToProps, object, LayoutMapContainerProps, IRootState>(
  mapStateToProps
)(LayoutMap)
